import React, {Component} from 'react';
import './LoadingScreen.css';

class LoadingScreen extends Component {


    render() {

        return (
            <div className="loading-screen">
                <img src={`/LoadingScreen.gif`} alt="Loading..." />
            </div>
        )
    }
}

export default LoadingScreen;